import React, { useRef } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import { DetailView } from './detail-view';
import { useCallbackAction } from 'src/hooks/use-actions';
import useToast from 'src/utils/toast-utils';
import useCarForms from 'src/api/cars/vm-form';
import useAssignForms from 'src/api/assign/vm-form';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);

  const { changeItem } = useCarForms();
  const { carToGroup } = useAssignForms();
  const { toastSuccess, toastError } = useToast();

  const changeInfors = (values) => useCallbackAction(changeItem, values, (result) => {
    toastSuccess(`Thông tin đã cập nhật`, {action: 'back'});
  }, toastError);
  const assignToGroup = (values) => useCallbackAction(carToGroup, values, (result) => {
    toastSuccess(`Đã bàn giao xe ${result}`, {action: 'back'});
  }, toastError);

  return (
    <PageSection title="Car" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.carManagement)}
        />
        <Stack spacing={1}>
          <DetailView item={item} apiChange={changeInfors} assignGroup={assignToGroup} />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;
